import { useMemo } from "react";
import { useIntl } from "react-intl";

import { Chip } from "@/components/Chip/Chip";
import type { City } from "@/types/types";

type Props = {
  onRecommendationClick: (city: City) => void;
  shouldShow?: (city: City) => boolean;
};

export function CitiesRecommendations({
  onRecommendationClick,
  shouldShow,
}: Props) {
  const intl = useIntl();
  const data = useMemo<City[]>(() => {
    const commonProps = {
      countryName: intl.formatMessage({ id: "searchRecommendations.iraq" }),
      countryCode: "IQ",
      type: "CITY" as const,
    };

    const cities = [
      {
        id: "1",
        name: intl.formatMessage({ id: "searchRecommendations.baghdad" }),
        code: "BGW",
      },
      {
        id: "34",
        name: intl.formatMessage({ id: "searchRecommendations.mosul" }),
        code: "",
      },
      {
        id: "31",
        name: intl.formatMessage({ id: "searchRecommendations.najaf" }),
        code: "NJF",
      },
      {
        id: "33",
        name: intl.formatMessage({ id: "searchRecommendations.erbil" }),
        code: "EBL",
      },
      {
        id: "32",
        name: intl.formatMessage({ id: "searchRecommendations.basra" }),
        code: "BSR",
      },
    ].map((city) => ({ ...commonProps, ...city }));

    if (shouldShow) {
      return cities.filter(shouldShow);
    }

    return cities;
  }, [intl, shouldShow]);

  return (
    <ul className="mt-4 -mb-2 flex w-full shrink-0 gap-2 overflow-x-auto pb-2">
      {data.map((city) => (
        <li key={city.id}>
          <Chip
            label={city.name}
            onClick={() => onRecommendationClick(city)}
            color="neutral"
            variant="outlined"
            shape="pill"
            size="medium"
          />
        </li>
      ))}
    </ul>
  );
}
